module.exports = __webpack_public_path__ + "static/img/gkcd.24dcd82.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gkcd.png
// module id = M2Qy
// module chunks = 1